import {
    Button,
    Card,
    CardContent,
    CircularProgress,
    Divider,
    Grid,
    TextField,
    Typography
} from '@material-ui/core';

import React, { Component } from 'react';

import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import ReplayIcon from '@material-ui/icons/Replay';
import StopIcon from '@material-ui/icons/Stop';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import api from '../../../services/api';

import AlertInformation from 'components/AlertInformation/AlertInformation';


class EscalaDetalhe extends Component {

    state = {

        escala: null,

        apontamentos: [],

        observacao: '',

        carregando: true,

        processando: false,

        openAlert: false,

        messageAlert: ''
    };


    estilo = {

        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,

        card: {
            maxWidth: 850,
            margin: '0 auto'
        },

        tituloCampo: {
            color: '#777',
            fontSize: 13,
            marginBottom: 3
        },

        valorCampo: {
            fontSize: 16,
            fontWeight: 500
        },

        bloco: {
            marginBottom: 20
        },

        botoes: {
            marginTop: 25,
            display: 'flex',
            gap: 10,
            flexWrap: 'wrap'
        },

        observacao: {
            marginTop: 25
        }
    };


    async componentDidMount() {

        await this.loadEscala();

    }


    /* =========================================================
       ID DA ESCALA
       ========================================================= */

    getIdItemEscala = () => {

        return this.props.match.params.idItemEscala;

    };


    /* =========================================================
       CARREGA DETALHE
       ========================================================= */

    loadEscala = async () => {

        const idItemEscala =
            this.getIdItemEscala();


        try {

            this.setState({
                carregando: true
            });


            const response =
                await api.get(
                    `/escala/item/${idItemEscala}`
                );


            let escala = null;


            if (
                response.data &&
                response.data.data
            ) {

                if (
                    Array.isArray(
                        response.data.data
                    )
                ) {

                    escala =
                        response.data.data[0];

                } else {

                    escala =
                        response.data.data;

                }

            } else {

                escala =
                    response.data;

            }


            this.setState({

                escala: escala,

                observacao:
                    escala?.obsoperador || '',

                apontamentos:
                    escala?.apontamentos || []

            });


        } catch (error) {

            console.error(error);

            this.handleOpenAlert(
                error.response?.data?.message ||
                'Erro ao carregar a escala.'
            );

        } finally {

            this.setState({
                carregando: false
            });

        }

    };


    /* =========================================================
       AÇÃO GENÉRICA
       ========================================================= */

    executarAcao = async (acao) => {

        const idItemEscala =
            this.getIdItemEscala();


        try {

            this.setState({
                processando: true
            });


            const body = {

                codMotorista:
                    Number(
                        sessionStorage.getItem(
                            'codMotorista'
                        )
                    ),

                codUsuario:
                    Number(
                        sessionStorage.getItem(
                            'codUser'
                        )
                    ),

                observacao:
                    this.state.observacao

            };


            await api.post(
                `/escala/${idItemEscala}/${acao}`,
                body
            );


            await this.loadEscala();


        } catch (error) {

            console.error(error);

            this.handleOpenAlert(
                error.response?.data?.message ||
                `Erro ao ${acao} trabalho.`
            );

        } finally {

            this.setState({
                processando: false
            });

        }

    };


    iniciar = () => {

        this.executarAcao('iniciar');

    };


    pausar = () => {

        this.executarAcao('pausar');

    };


    retomar = () => {

        this.executarAcao('retomar');

    };


    finalizar = () => {

        this.executarAcao('finalizar');

    };


    /* =========================================================
       OBSERVAÇÃO
       ========================================================= */

    handleObservacao = (event) => {

        this.setState({
            observacao:
                event.target.value
        });

    };


    /* =========================================================
       STATUS
       ========================================================= */

    descricaoStatus = (status) => {

        switch (status) {

            case 'P':
                return 'Programada';

            case 'E':
                return 'Em execução';

            case 'F':
                return 'Finalizada';

            case 'C':
                return 'Cancelada';

            default:
                return status || '';

        }

    };


    /* =========================================================
       VERIFICA SE ESTÁ PAUSADA
       ========================================================= */

    estaPausada = () => {

        const {
            escala
        } = this.state;


        return (
            escala &&
            (
                escala.pausada === true ||
                escala.pausada === 'S'
            )
        );

    };


    /* =========================================================
       DATA
       ========================================================= */

    formatarData = (data) => {

        if (!data)
            return '';


        const valor =
            String(data)
                .substring(0, 10);


        const partes =
            valor.split('-');


        if (partes.length !== 3)
            return data;


        return (
            partes[2] +
            '/' +
            partes[1] +
            '/' +
            partes[0]
        );

    };


    /* =========================================================
       DESCRIÇÃO DO TIPO DE APONTAMENTO
       ========================================================= */

    descricaoTipoApontamento = (tipo) => {

        switch (tipo) {

            case 'I':
                return 'Início';

            case 'P':
                return 'Pausa';

            case 'R':
                return 'Retomada';

            case 'F':
                return 'Finalização';

            default:
                return tipo || '';

        }

    };


    /* =========================================================
       FORMATA DATA/HORA DO APONTAMENTO
       ========================================================= */

    formatarDataHora = (dataHora) => {

        if (!dataHora)
            return '';

        const data = new Date(dataHora);

        if (isNaN(data.getTime()))
            return dataHora;

        return data.toLocaleString(
            'pt-BR',
            {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }
        );

    };


    /* =========================================================
       VOLTAR
       ========================================================= */

    voltar = () => {

        this.props.history.push(
            '/front/escala'
        );

    };


    /* =========================================================
       ALERTAS
       ========================================================= */

    handleOpenAlert = (message) => {

        this.setState({
            openAlert: true,
            messageAlert: message
        });

    };


    handleCloseAlert = () => {

        this.setState({
            openAlert: false
        });

    };

    /* =========================================================
   FORMATA MINUTOS EM HORAS / MINUTOS
   ========================================================= */

    formatarMinutos = (totalMinutos) => {

        if (
            totalMinutos === null ||
            totalMinutos === undefined ||
            isNaN(totalMinutos)
        ) {
            return '0min';
        }

        const minutos =
            Math.max(
                0,
                Math.round(totalMinutos)
            );

        const horas =
            Math.floor(minutos / 60);

        const restoMinutos =
            minutos % 60;


        if (horas > 0 && restoMinutos > 0) {

            return `${horas}h ${restoMinutos}min`;

        }


        if (horas > 0) {

            return `${horas}h`;

        }


        return `${restoMinutos}min`;

    };


    /* =========================================================
       CALCULA TEMPOS DA EXECUÇÃO
       ========================================================= */

    calcularTempos = (apontamentos) => {

        const resultado = {

            minutosTrabalhados: 0,

            minutosIntervalo: 0,

            minutosTotais: 0,

            inicio: null,

            fim: null

        };


        if (
            !Array.isArray(apontamentos) ||
            apontamentos.length === 0
        ) {

            return resultado;

        }


        /*
         * Faz uma cópia e ordena por data/hora.
         *
         * O ID é usado como desempate caso existam
         * dois eventos com o mesmo horário.
         */

        const lista =
            [...apontamentos]
                .sort((a, b) => {

                    const dataA =
                        new Date(a.datahora).getTime();

                    const dataB =
                        new Date(b.datahora).getTime();


                    if (dataA !== dataB) {

                        return dataA - dataB;

                    }


                    return (
                        Number(a.idapontamento || 0) -
                        Number(b.idapontamento || 0)
                    );

                });


        let estado = null;

        let dataUltimaMudanca = null;


        for (
            let i = 0;
            i < lista.length;
            i++
        ) {

            const apontamento =
                lista[i];

            const tipo =
                apontamento.tipo;

            const dataAtual =
                new Date(
                    apontamento.datahora
                );


            if (
                isNaN(
                    dataAtual.getTime()
                )
            ) {

                continue;

            }


            /* INÍCIO */

            if (tipo === 'I') {

                if (!resultado.inicio) {

                    resultado.inicio =
                        dataAtual;

                }


                estado =
                    'TRABALHANDO';

                dataUltimaMudanca =
                    dataAtual;

                continue;

            }


            /*
             * Se ainda não houve início válido,
             * ignoramos outros eventos.
             */

            if (
                !dataUltimaMudanca ||
                !estado
            ) {

                continue;

            }


            const diferencaMinutos =
                (
                    dataAtual.getTime() -
                    dataUltimaMudanca.getTime()
                ) / 60000;


            /* PAUSA */

            if (tipo === 'P') {

                if (estado === 'TRABALHANDO') {

                    resultado.minutosTrabalhados +=
                        Math.max(
                            0,
                            diferencaMinutos
                        );

                }


                estado =
                    'PAUSADO';

                dataUltimaMudanca =
                    dataAtual;

                continue;

            }


            /* RETOMADA */

            if (tipo === 'R') {

                if (estado === 'PAUSADO') {

                    resultado.minutosIntervalo +=
                        Math.max(
                            0,
                            diferencaMinutos
                        );

                }


                estado =
                    'TRABALHANDO';

                dataUltimaMudanca =
                    dataAtual;

                continue;

            }


            /* FINALIZAÇÃO */

            if (tipo === 'F') {

                if (estado === 'TRABALHANDO') {

                    resultado.minutosTrabalhados +=
                        Math.max(
                            0,
                            diferencaMinutos
                        );

                } else if (
                    estado === 'PAUSADO'
                ) {

                    resultado.minutosIntervalo +=
                        Math.max(
                            0,
                            diferencaMinutos
                        );

                }


                resultado.fim =
                    dataAtual;


                estado =
                    'FINALIZADO';

                dataUltimaMudanca =
                    dataAtual;

                break;

            }

        }


        /*
         * Tempo total:
         *
         * início até finalização.
         *
         * Se ainda não finalizou, usa o momento atual.
         */

        if (resultado.inicio) {

            const dataFim =
                resultado.fim ||
                new Date();


            resultado.minutosTotais =
                Math.max(
                    0,
                    (
                        dataFim.getTime() -
                        resultado.inicio.getTime()
                    ) / 60000
                );

        }


        /*
         * Se ainda estiver trabalhando ou pausado,
         * soma também o período em aberto até agora.
         */

        if (
            !resultado.fim &&
            dataUltimaMudanca
        ) {

            const agora =
                new Date();

            const minutosAbertos =
                Math.max(
                    0,
                    (
                        agora.getTime() -
                        dataUltimaMudanca.getTime()
                    ) / 60000
                );


            if (estado === 'TRABALHANDO') {

                resultado.minutosTrabalhados +=
                    minutosAbertos;

            } else if (
                estado === 'PAUSADO'
            ) {

                resultado.minutosIntervalo +=
                    minutosAbertos;

            }

        }


        return resultado;

    };


    render() {

        const {
            escala,
            observacao,
            apontamentos,
            carregando,
            processando
        } = this.state;


        if (carregando) {

            return (

                <div
                    style={{
                        padding: 40,
                        textAlign: 'center'
                    }}
                >

                    <CircularProgress />

                </div>

            );

        }


        if (!escala) {

            return (

                <div
                    style={{
                        padding: 30
                    }}
                >

                    <Typography>
                        Escala não localizada.
                    </Typography>

                </div>

            );

        }


        const status =
            escala.statusitem ||
            escala.status;


        const pausada =
            this.estaPausada();

        const temposCalculados =
            this.calcularTempos(
                apontamentos
            );


        const tempos =
            status === 'F'
                ? {
                    minutosTrabalhados:
                        Number(
                            escala.totalminutostrabalhados || 0
                        ),

                    minutosIntervalo:
                        Number(
                            escala.totalminutosintervalo || 0
                        ),

                    minutosTotais:
                        Number(
                            escala.totalminutos || 0
                        )
                }
                : temposCalculados;
        return (

            <div style={this.estilo}>


                <Card
                    style={this.estilo.card}
                >

                    <CardContent>


                        <Button
                            color="primary"
                            onClick={this.voltar}
                        >

                            <ArrowBackIcon />

                            Voltar

                        </Button>


                        <Typography
                            variant="h5"
                            style={{
                                marginTop: 10,
                                marginBottom: 25
                            }}
                        >
                            Escala do Dia
                        </Typography>


                        <Grid
                            container
                            spacing={3}
                        >


                            <Grid
                                item
                                xs={12}
                                sm={4}
                            >

                                <Typography
                                    style={
                                        this.estilo.tituloCampo
                                    }
                                >
                                    Data
                                </Typography>

                                <Typography
                                    style={
                                        this.estilo.valorCampo
                                    }
                                >
                                    {
                                        this.formatarData(
                                            escala.data
                                        )
                                    }
                                </Typography>

                            </Grid>


                            <Grid
                                item
                                xs={12}
                                sm={8}
                            >

                                <Typography
                                    style={
                                        this.estilo.tituloCampo
                                    }
                                >
                                    Status
                                </Typography>

                                <Typography
                                    style={
                                        this.estilo.valorCampo
                                    }
                                >
                                    {
                                        pausada
                                            ? 'Em intervalo'
                                            : this.descricaoStatus(
                                                status
                                            )
                                    }
                                </Typography>

                            </Grid>


                            <Grid
                                item
                                xs={12}
                            >

                                <Divider />

                            </Grid>


                            <Grid
                                item
                                xs={12}
                                sm={6}
                            >

                                <Typography
                                    style={
                                        this.estilo.tituloCampo
                                    }
                                >
                                    Cliente
                                </Typography>

                                <Typography
                                    style={
                                        this.estilo.valorCampo
                                    }
                                >

                                    {
                                        escala.cliente ||
                                        escala.nomecliente ||
                                        ''
                                    }

                                </Typography>

                            </Grid>


                            <Grid
                                item
                                xs={12}
                                sm={6}
                            >

                                <Typography
                                    style={
                                        this.estilo.tituloCampo
                                    }
                                >
                                    Projeto / Obra
                                </Typography>

                                <Typography
                                    style={
                                        this.estilo.valorCampo
                                    }
                                >

                                    {
                                        escala.projeto ||
                                        escala.descricaoprojeto ||
                                        escala.descricao ||
                                        ''
                                    }

                                </Typography>

                            </Grid>


                            <Grid
                                item
                                xs={12}
                                sm={6}
                            >

                                <Typography
                                    style={
                                        this.estilo.tituloCampo
                                    }
                                >
                                    Serviço
                                </Typography>

                                <Typography
                                    style={
                                        this.estilo.valorCampo
                                    }
                                >

                                    {
                                        escala.servico ||
                                        escala.descservico ||
                                        ''
                                    }

                                </Typography>

                            </Grid>


                            <Grid
                                item
                                xs={12}
                                sm={6}
                            >

                                <Typography
                                    style={
                                        this.estilo.tituloCampo
                                    }
                                >
                                    Veículo / Máquina
                                </Typography>

                                <Typography
                                    style={
                                        this.estilo.valorCampo
                                    }
                                >

                                    {
                                        escala.veiculo ||
                                        escala.descveiculo ||
                                        ''
                                    }

                                </Typography>

                            </Grid>


                            {
                                escala.horaprevistainicio && (

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                    >

                                        <Typography
                                            style={
                                                this.estilo.tituloCampo
                                            }
                                        >
                                            Horário previsto
                                        </Typography>

                                        <Typography
                                            style={
                                                this.estilo.valorCampo
                                            }
                                        >

                                            {
                                                escala.horaprevistainicio
                                            }

                                            {' até '}

                                            {
                                                escala.horaprevistafim
                                            }

                                        </Typography>

                                    </Grid>

                                )
                            }


                            {
                                escala.horainicio && (

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                    >

                                        <Typography
                                            style={
                                                this.estilo.tituloCampo
                                            }
                                        >
                                            Iniciado
                                        </Typography>

                                        <Typography
                                            style={
                                                this.estilo.valorCampo
                                            }
                                        >
                                            {
                                                escala.horainicio
                                            }
                                        </Typography>

                                    </Grid>

                                )
                            }


                        </Grid>


                        <div
                            style={
                                this.estilo.observacao
                            }
                        >

                            <TextField
                                label="Observação do operador"
                                multiline
                                rows={4}
                                fullWidth
                                variant="outlined"
                                value={observacao}
                                onChange={
                                    this.handleObservacao
                                }
                                disabled={
                                    status === 'F' ||
                                    status === 'C'
                                }
                            />

                        </div>


                        {/* =====================================================
                            HISTÓRICO DO TRABALHO
                            ===================================================== */}

                        {
                            apontamentos &&
                            apontamentos.length > 0 && (

                                <div
                                    style={{
                                        marginTop: 30
                                    }}
                                >

                                    <Divider />


                                    <Typography
                                        variant="h6"
                                        style={{
                                            marginTop: 20,
                                            marginBottom: 15
                                        }}
                                    >
                                        Histórico do trabalho
                                    </Typography>


                                    {
                                        apontamentos.map(
                                            (apontamento, index) => (

                                                <div
                                                    key={
                                                        apontamento.idapontamento ||
                                                        index
                                                    }
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginBottom: 12
                                                    }}
                                                >

                                                    <div
                                                        style={{
                                                            width: 34,
                                                            height: 34,
                                                            borderRadius: '50%',
                                                            backgroundColor: '#eeeeee',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginRight: 12,
                                                            fontWeight: 'bold',
                                                            flexShrink: 0
                                                        }}
                                                    >

                                                        {
                                                            apontamento.tipo === 'I'
                                                                ? '▶'
                                                                : apontamento.tipo === 'P'
                                                                    ? 'Ⅱ'
                                                                    : apontamento.tipo === 'R'
                                                                        ? '▶'
                                                                        : apontamento.tipo === 'F'
                                                                            ? '■'
                                                                            : '•'
                                                        }

                                                    </div>


                                                    <div>

                                                        <Typography
                                                            style={{
                                                                fontWeight: 500
                                                            }}
                                                        >
                                                            {
                                                                this.descricaoTipoApontamento(
                                                                    apontamento.tipo
                                                                )
                                                            }
                                                        </Typography>


                                                        <Typography
                                                            style={{
                                                                fontSize: 13,
                                                                color: '#777'
                                                            }}
                                                        >
                                                            {
                                                                this.formatarDataHora(
                                                                    apontamento.datahora
                                                                )
                                                            }
                                                        </Typography>


                                                        {
                                                            apontamento.observacao && (

                                                                <Typography
                                                                    style={{
                                                                        fontSize: 13,
                                                                        color: '#777',
                                                                        marginTop: 2
                                                                    }}
                                                                >
                                                                    {
                                                                        apontamento.observacao
                                                                    }
                                                                </Typography>

                                                            )
                                                        }

                                                    </div>

                                                </div>

                                            )
                                        )
                                    }

                                </div>

                            )
                        }


                        {/* =====================================================
                            BOTÕES DE AÇÃO
                            ===================================================== */}

                        <div
                            style={
                                this.estilo.botoes
                            }
                        >


                            {
                                status === 'P' && (

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        disabled={
                                            processando
                                        }
                                        onClick={
                                            this.iniciar
                                        }
                                    >

                                        <PlayArrowIcon
                                            style={{
                                                marginRight: 5
                                            }}
                                        />

                                        Iniciar trabalho

                                    </Button>

                                )
                            }


                            {
                                status === 'E' &&
                                !pausada && (

                                    <Button
                                        variant="contained"
                                        size="large"
                                        disabled={
                                            processando
                                        }
                                        onClick={
                                            this.pausar
                                        }
                                    >

                                        <PauseIcon
                                            style={{
                                                marginRight: 5
                                            }}
                                        />

                                        Pausar

                                    </Button>

                                )
                            }


                            {
                                status === 'E' &&
                                pausada && (

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        disabled={
                                            processando
                                        }
                                        onClick={
                                            this.retomar
                                        }
                                    >

                                        <ReplayIcon
                                            style={{
                                                marginRight: 5
                                            }}
                                        />

                                        Retomar

                                    </Button>

                                )
                            }


                            {
                                status === 'E' && (

                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        size="large"
                                        disabled={
                                            processando
                                        }
                                        onClick={
                                            this.finalizar
                                        }
                                    >

                                        <StopIcon
                                            style={{
                                                marginRight: 5
                                            }}
                                        />

                                        Finalizar trabalho

                                    </Button>

                                )
                            }


                            {
                                status === 'F' && (

                                    <Typography
                                        variant="h6"
                                    >

                                        Trabalho finalizado

                                    </Typography>

                                )
                            }


                        </div>

                        {/* =====================================================
    RESUMO DA EXECUÇÃO
    ===================================================== */}

                        {
                            apontamentos &&
                            apontamentos.length > 0 && (

                                <div
                                    style={{
                                        marginTop: 25
                                    }}
                                >

                                    <Divider />


                                    <Typography
                                        variant="h6"
                                        style={{
                                            marginTop: 20,
                                            marginBottom: 15
                                        }}
                                    >
                                        Resumo da execução
                                    </Typography>


                                    <Grid
                                        container
                                        spacing={2}
                                    >


                                        <Grid
                                            item
                                            xs={12}
                                            sm={4}
                                        >

                                            <Typography
                                                style={
                                                    this.estilo.tituloCampo
                                                }
                                            >
                                                Tempo trabalhado
                                            </Typography>

                                            <Typography
                                                style={
                                                    this.estilo.valorCampo
                                                }
                                            >
                                                {
                                                    this.formatarMinutos(
                                                        tempos.minutosTrabalhados
                                                    )
                                                }
                                            </Typography>

                                        </Grid>


                                        <Grid
                                            item
                                            xs={12}
                                            sm={4}
                                        >

                                            <Typography
                                                style={
                                                    this.estilo.tituloCampo
                                                }
                                            >
                                                Tempo em intervalo
                                            </Typography>

                                            <Typography
                                                style={
                                                    this.estilo.valorCampo
                                                }
                                            >
                                                {
                                                    this.formatarMinutos(
                                                        tempos.minutosIntervalo
                                                    )
                                                }
                                            </Typography>

                                        </Grid>


                                        <Grid
                                            item
                                            xs={12}
                                            sm={4}
                                        >

                                            <Typography
                                                style={
                                                    this.estilo.tituloCampo
                                                }
                                            >
                                                Tempo total
                                            </Typography>

                                            <Typography
                                                style={
                                                    this.estilo.valorCampo
                                                }
                                            >
                                                {
                                                    this.formatarMinutos(
                                                        tempos.minutosTotais
                                                    )
                                                }
                                            </Typography>

                                        </Grid>


                                    </Grid>

                                </div>

                            )
                        }


                    </CardContent>

                </Card>


                <AlertInformation

                    open={
                        this.state.openAlert
                    }

                    handleClose={
                        this.handleCloseAlert
                    }

                    message={
                        this.state.messageAlert
                    }

                />


            </div>

        );

    }

}


export default EscalaDetalhe;